const {loadGoogleMaps} = require('od-modules/helpers/map/googleMapsLoader');
const {hasMapFullScreenChanged} = require('od-modules/helpers/map/full_screen');
const MapEvents = require('od-modules/helpers/map/events');
const MAP_OPTIONS = {
    mapTypeControl: true,
    center: 0,
    zoom: 17,
    mapTypeId: '',
    scrollwheel: false,
    disableDefaultUI: false,
    mapTypeControlOptions: {},
    draggable: true,
    disableDoubleClickZoom: false,
    mockType: 'ui_map',
    hasIconMarkerBrand: false,
    fullscreenControl: false,
    latitude: 0,
    longitude: 0,
    mapView: null,
    mapId: '1d274f1764b4583',
};

function initMap(GM) {
    this.marker = null;
    this.googleMap = GM;
    this.options.center = new this.googleMap.LatLng(this.options.latitude, this.options.longitude);
    this.options.mapTypeId = this.googleMap.MapTypeId.ROADMAP;
    this.map = new this.googleMap.Map(this.options.mapView, this.options);
}

function initMarker() {
    const MarkerConstructor = this.options.hasIconMarkerBrand
        ? require('od-modules/helpers/map/marker/marker_brand')(this.googleMap)
        : this.googleMap.Marker;

    this.marker = new MarkerConstructor({
        map: this.map,
        position: this.options.center,
    });
}

function resizeMap() {
    this.googleMap.event.trigger(this.map, 'resize');
    this.map.setCenter(this.marker.position);
}

function getMapElement() {
    return Odigeo._.result(this.map, 'getDiv', null);
}

module.exports = class UiGoogleMap {
    constructor(options) {
        this.googleMap = null;
        this.map = null;
        this.options = Object.assign({}, MAP_OPTIONS, options);
    }

    async update(options) {
        Object.assign(this.options, options);
        this.libMap = await loadGoogleMaps();
        if (this.libMap) {
            initMap.call(this, this.libMap);
            initMarker.call(this);
        }
        return this.map.getDiv();
    }

    refreshMap() {
        resizeMap.call(this);
    }

    hasMapElement(mapView) {
        const uiMapView = getMapElement.call(this);

        return uiMapView === mapView && Odigeo._.isElement(uiMapView.firstChild);
    }

    onFullScreen(fn) {
        if (typeof fn === 'function') {
            MapEvents.getListeners(this.libMap).rebindListeners(this.map, {
                'bounds_changed': function() {
                    if (hasMapFullScreenChanged()) {
                        fn.call();
                    }
                },
            });
        }
    }
};
